import { Flex } from '@chakra-ui/react';
import React from 'react';
import { Navigate } from 'react-router';

import { Typography } from 'packages/common-frontend/components/Typography';
import { AggregatedLimitedPartnerCommitmentsTableContainer } from 'packages/limitedPartners/ui/AggregatedLimitedPartnerCommitmentsTable';
import { ActionsMenu } from 'packages/limitedPartners/ui/LimitedPartnersDashboard';
import { RouteErrorBoundary } from '~/contexts/MonitoringProvider';
import { Breadcrumbs } from '~/packages/common-frontend/components/Breadcrumbs';

const RouteBase = () => {
  return (
    <>
      <Flex justifyContent="space-between" mb="1.5rem">
        <Breadcrumbs
          breadcrumbs={[
            { label: 'Limited Partners', path: `/limited-partners` },
          ]}
        />
        <ActionsMenu />
      </Flex>
      <Typography variant="page-title" trim>
        LPs
      </Typography>
      <AggregatedLimitedPartnerCommitmentsTableContainer />
    </>
  );
};

// @makarand-citizens: investigate if this route is ever used.
// if unused AggregatedLimitedPartnerCommitmentsTableContainer can be changed
// to require filters.
export const Route = () => {
  return (
    <RouteErrorBoundary
      fallback={({ message, showErrorToast }) => {
        showErrorToast(message);
        return <Navigate to="/" />;
      }}
    >
      <Flex
        direction="column"
        padding={['1.5rem', '1.5rem', '1.5rem', '2.5rem']}
      >
        <RouteBase />
      </Flex>
    </RouteErrorBoundary>
  );
};
